'use strict';

var Field = require('./Field');

angular.module('dekky.forms.fields.uiDatepicker', ['ui.bootstrap'])
.factory('UiDatepickerField', function($q) {
	function uiDatepickerFactory(name, options) {
		function UiDatepicker(name, options) {
			this.type = 'uiDatepicker';
			this.dateOptions = options.dateOptions;
			this.format = options.format;

			Field.apply(this, arguments);
		}

		UiDatepicker.prototype = Object.create(Field.prototype);
		UiDatepicker.prototype.link = function(template, scope) {
			scope.popup = {opened: false};
			scope.open = function() {
				scope.popup.opened = true;
			};

			return $q.when(template);
		};

		return new UiDatepicker(name, options);
	}

	return uiDatepickerFactory;
});